import {
  FileContentType,
  FileType,
  IFileRefGetBaseName,
  IFileRefGetCleanPath,
  IFileReference,
  IFileRefIsLocal
} from '@summit/core';

import { EboObjectTO } from '../base-classes/ebo-object-to';
import { Employee } from './employee';

export class EmployeeFile extends EboObjectTO implements IFileReference {
  employeeID: string;
  employee: Employee;
  name: string;
  path: string;
  blobPath: string; // Required for dynamic file loading
  order: number;
  fileType: FileType;
  contentType: FileContentType;

  constructor(jsonData: Partial<EmployeeFile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.employee) this.employee = new Employee(jsonData.employee);
    }
    this.contentType ??= FileContentType.Attachment;
  }

  get baseName(): string {
    return IFileRefGetBaseName(this);
  }
  get cleanPath(): string {
    return IFileRefGetCleanPath(this);
  }
  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
